import { gql, useQuery } from '@apollo/client';
import { FETCH_POLICY } from 'src/components/common/apollo/FETCH_POLICY';
import { DEFAULT_TIMEZONE_OPTION } from '../../components/common/SimpleTimezoneSelect/defaults';
import { TimezoneOption } from '../../components/common/SimpleTimezoneSelect/types';
import { useLoggedInUser } from './useLoggedInUser';

export const GET_TIMEZONES = gql`
  query GetTimezones {
    timezones
  }
`;

export const useTimezones = (customTimezones?: string[]) => {
  const user = useLoggedInUser();
  const { data, loading } = useQuery<{ timezones: string[] }, EmptyObject>(GET_TIMEZONES, {
    fetchPolicy: FETCH_POLICY.CACHE_FIRST,
    skip: !user || !!customTimezones // Prevent page infinite reload.
  });

  const timezones = customTimezones || data?.timezones || [DEFAULT_TIMEZONE_OPTION.value];
  return { timezoneOptions: timezones.map(timezoneToSelectOption), loading };
};

export const timezoneToSelectOption = (timezone: string): TimezoneOption => ({ value: timezone, label: timezone });
